import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatBytes",
  standalone: false,
})
export class FormatBytesPipe implements PipeTransform {
  transform(value: number, decimals: number = 2): unknown {
    if (value == 0) return "0 Bytes";
    const k = 1024,
      dm = decimals || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(value) / Math.log(k));
    return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
